var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    fill: "none",
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    fillRule: "evenodd",
    d: "M44 88c24.028 0 43.506-19.7 43.506-44 0-9.996-3.296-19.213-8.849-26.601C70.713 6.826 58.144 0 44 0 19.973 0 .494 19.7.494 44S19.973 88 44 88z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M66.233 34.14l.007-.008.008-.008c1.002-1.122 1.005-2.85-.034-3.977-1.099-1.191-2.948-1.256-4.127-.144L37.232 53.456l-7.916-7.885-.008-.008-.008-.007-.154-.142-.008-.007-.009-.007c-1.154-.968-2.871-.898-3.942.203-1.128 1.158-1.114 3.019.031 4.16l9.911 9.871.008.008.008.007.159.145.008.008.008.007c1.12.934 2.77.9 3.85-.12l26.901-25.384.008-.008.008-.007.146-.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSuccess);
export default __webpack_public_path__ + "static/media/action-success.b9900166c93ed0901c93efc6be3ec937.svg";
export { ForwardRef as ReactComponent };